export const DeepBioActions = {
    UPDATE_AI_RESULTS_DISPLAYED: "UPDATE_AI_RESULTS_DISPLAYED",
    UPDATE_FILTER_COLOR: "UPDATE_FILTER_COLOR",
}